import { useState } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import {
  Alert,
  AlertDescription,
  AlertTitle,
  DateRange,
} from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

import DatasourceTypeRenderer from 'modules/ai_reports/components/DatasourceTypeRenderer'
import { ColumnFormatHint } from 'modules/ai_reports/components/DatasourceTypeRenderer/utils'
import { AiReportsResult } from 'modules/ai_reports/lib/useCreateAnalyticsReportActionResolver'

import { ViewQuery } from './components/ViewQuery'

type ReportWidgetProps = {
  id: string
  dateFilter: DateRange | undefined
  tableId: string
  columnFormatHints: ColumnFormatHint[]
  reportName: string
  onChangeFilters: (filters: AiReportsResult['filters']) => void
  sqlQuery?: string
  description?: string
  hideMetadata?: boolean
}

export const ReportWidget = ({
  id,
  dateFilter,
  tableId,
  columnFormatHints,
  reportName,
  onChangeFilters,
  sqlQuery,
  description,
  hideMetadata = false,
}: ReportWidgetProps) => {
  const [userFacingSqlQuery, setUserFacingSqlQuery] = useState('')

  return (
    <>
      {!hideMetadata && (description || userFacingSqlQuery) && (
        <Box paddingX="s16">
          <Box paddingBottom="s16">
            <Alert>
              <AlertTitle>{i18n.t('ai_reports.reports.question_description')}</AlertTitle>
              <AlertDescription>
                <Box paddingBottom="s16">{description}</Box>
                {userFacingSqlQuery && <ViewQuery query={userFacingSqlQuery} />}
              </AlertDescription>
            </Alert>
          </Box>
        </Box>
      )}

      {sqlQuery && (
        <DatasourceTypeRenderer
          id={id}
          dateFilter={dateFilter}
          tableId={tableId}
          columnFormatHints={columnFormatHints}
          reportName={reportName}
          sqlQuery={sqlQuery}
          setFilters={onChangeFilters}
          onUserFacingSqlQueryChange={setUserFacingSqlQuery}
        />
      )}
    </>
  )
}
